import { Link } from 'react-router-dom';
import type { Project } from '@mockd/shared';
import { LimitIndicator } from '../common';

interface ProjectCardProps {
  project: Project;
  endpointCount?: number;
  endpointLimit?: number;
}

// An undefined endpointCount means the count couldn't be fetched: omit it rather than claim 0
export function ProjectCard({ project, endpointCount, endpointLimit }: ProjectCardProps) {
  const isAnonymous = !project.userId;

  return (
    <div className="card bg-base-100">
      <Link to={`/projects/${project.id}`} className="block p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h3 className="text-base-content truncate">
              {project.name}
            </h3>
            {isAnonymous && (
              <p className="text-xs text-base-content/70 mt-0.5">Temporary anonymous endpoint</p>
            )}
            <p className="text-sm text-neutral-content mt-1">
              <code className="text-xs bg-neutral px-1.5 py-0.5 rounded-field">
                {project.subdomain}
              </code>
            </p>
          </div>
        </div>

        {endpointCount != null && (
          <div className="mt-4">
            {endpointLimit != null ? (
              <LimitIndicator used={endpointCount} max={endpointLimit} label="Endpoints" />
            ) : (
              <span className="text-sm text-base-content/80">
                {endpointCount} {endpointCount === 1 ? 'endpoint' : 'endpoints'}
              </span>
            )}
          </div>
        )}
      </Link>
    </div>
  );
}
